import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: '대시보드',
    link: '/dashboard',
  },
  {
    id: 2,
    label: '회원 관리',
    link: '/userlist',
  },
  {
    id: 3,
    label: '공명 관리',
    link: '/meditationlist',
  },
  {
    id: 4,
    label: '배경 관리',
    subItems: [
      {
        id: 5,
        label: '홈 관리',
        link: '/home-management',
        parentId: 4,
      },
      {
        id: 6,
        label: '다이어리 배경 관리',
        link: '/diary-management',
        parentId: 4,
      },
      {
        id: 'daily',
        label: '데일리 명상 관리',
        link: '/daily-management',
        parentId: 4,
      },
      {
        id: 'energy',
        label: '에너지 명상 배경 관리',
        link: '/energy-management',
        parentId: 4,
      },
    ],
  },
  {
    id: 7,
    label: '콘텐츠 관리',
    subItems: [
      {
        id: 8,
        label: '홈 카테고리 관리',
        link: '/home-category',
        parentId: 7,
      },
      {
        id: 9,
        label: '명상 관리',
        link: '/keyword-management',
        parentId: 7,
      },
      {
        id: 10,
        label: '다이어리 사용법 관리',
        link: '/diary-manual',
        parentId: 7,
      },
      {
        id: 11,
        label: '배너 관리',
        link: '/banner-management',
        parentId: 7,
      },
    ],
  },
  {
    id: 12,
    label: '이용권 관리',
    link: '/productlist',
  },
  {
    id: 13,
    label: '이용권 내역 관리',
    link: '/product-breakdown-list',
  },
  {
    id: 14,
    label: '서비스/정보 관리',
    link: '',
    subItems: [
      {
        id: 15,
        label: '공지사항 관리',
        link: '/notice',
        parentId: 14,
      },
      {
        id: 16,
        label: '질문 관리',
        link: '/questionslist',
        parentId: 14,
      },
      {
        id: 17,
        label: '이용약관/개인정보',
        link: '/terms',
        parentId: 14,
      },
    ],
  },
];
